<template>
  <div v-if="!isClassDataEmpty" class="">
    <div class="pa-3 pa-sm-4 pa-md-2">
      <Breadcrumbs
        v-if="classData"
        data="classData.title"
        :headline="`${classData.title} (${classData.code})`"
        :link="[
          { text: 'Lớp học', href: '../../../classes' },
          {
            text: `${classData.title} (${classData.code})`,
            id: classData.id,
            href: `../../class/${classData.id}`
          },
          { text: 'Phiếu Điểm' }
        ]"
      />
    </div>
    <v-card elevation="1" class="mt-3 mx-md-2 px-3">
      <v-layout v-if="classData">
        <v-flex md12 xs12 sm12>
          <div>
            <div>
              <div class="d-flex">
                <MarkBreadcrumb></MarkBreadcrumb>
              </div>
              <div v-if="canSeeMarkSheets">
                <BaseTableSkeletonLoader
                  v-if="isLoading && !tableData.length"
                ></BaseTableSkeletonLoader>
                <div
                  class="d-flex flex-column flex-sm-row px-4 py-6 py-sm-2 align-center"
                  v-else-if="!markSheetData"
                >
                  <p class="mb-0">Không có phiếu điểm nào để hiển thị</p>
                  <v-btn
                    v-if="!this.isLocked && canEditMarkSheet"
                    @click="onClickEditMarkSheet"
                    class="ml-0 ml-sm-2 mt-2 mt-sm-0"
                    :elevation="0"
                    color="primary"
                    text
                  >
                    Tạo phiếu điểm
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </div>
                <template v-else>
                  <div class="pa-4">
                    <div class="mb-1 d-flex justify-space-between justify-sm-start align-center">
                      <span class="subtitle-1">
                        <v-icon class="mr-1" small title="Đã khóa" color="grey " v-if="isLocked">
                          lock
                        </v-icon>
                        {{ markSheetData.title }}</span
                      >
                      <div v-if="!this.isLocked && canEditMarkSheet" class="d-inline-flex ml-1">
                        <v-btn icon small>
                          <v-icon small @click="onClickEditMarkSheet">mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon small>
                          <v-icon small @click="onClickDeleteSheet">mdi-delete</v-icon>
                        </v-btn>
                        <v-btn icon small>
                          <v-icon small @click="onClickSyncCourseMapConfig">mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <p class="mb-1">Giáo viên chấm: {{ markSheetData.assigned_teacher.name }}</p>
                    <p class="mb-0 body-1" v-if="!!markSheetData.note">
                      Mô tả: {{ markSheetData.note }}
                    </p>
                  </div>
                  <v-data-table
                    item-class="row-class"
                    :headers="headers"
                    :items="tableData"
                    hide-default-footer
                    :disable-pagination="true"
                    :mobile-breakpoint="0"
                    disableSort
                  >
                    <template v-slot:[`header.mark.value`]="">
                      <div class="d-flex align-center">
                        Điểm
                        <v-btn
                          v-if="!isLocked"
                          text
                          icon
                          small
                          @click.stop="onClickEditMark('value')"
                          title="Sửa điểm"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <template v-slot:[`header.mark.drive_link`]="">
                      <div class="d-flex align-center">
                        Link file drive
                        <v-btn
                          v-if="!isLocked"
                          text
                          icon
                          small
                          @click.stop="onClickEditMark('drive_link')"
                          title="Sửa link file drive"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <template v-slot:no-data="">
                      Không có học viên nào đạt điều kiện thi lại
                    </template>
                    <template v-slot:item.index="{ item }">
                      {{ item.index + 1 }}
                    </template>
                    <template v-slot:[`item.mark.drive_link`]="{ item }">
                      <div v-if="item.mark.drive_link">
                        <v-btn
                          icon
                          target="_blank"
                          :href="item.mark.drive_link"
                          v-if="$vuetify.breakpoint.mobile"
                          small
                        >
                          <v-icon small> mdi-open-in-new </v-icon>
                        </v-btn>
                        <a
                          target="_blank"
                          :href="item.mark.drive_link"
                          v-else
                          class="d-block drive-link text-truncate"
                        >
                          {{ item.mark.drive_link }}</a
                        >
                      </div>
                    </template>
                    <template v-slot:[`item.mark.note`]="{ item }">
                      <div class="d-flex align-center" v-if="(item.mark || {}).id">
                        <p class="text-truncate mark-note mb-0">
                          {{ (item.mark || {}).note }}
                        </p>
                        <v-btn
                          v-if="!isLocked"
                          class=""
                          icon
                          small
                          @click="onClickEditMarkNote(item)"
                        >
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <template v-slot:item.name="{ item }">
                      {{ item.name }}
                      <!-- <v-tooltip v-if="!studentQualificationStatus[item._id]" top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" slot="activator">mdi-information</v-icon>
                      </template>
                      Sinh viên không đủ điều kiện tham gia lớp học
                    </v-tooltip> -->
                    </template>
                    <template v-slot:item.actions="{ item }" v-if="canEditMark">
                      <div class="d-flex align-center" v-if="!isLocked">
                        <!-- <v-btn text icon small @click.stop="onClickEditMark(item)" title="Sửa điểm">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn> -->
                        <v-btn
                          v-if="(item.mark || {}).id"
                          text
                          icon
                          small
                          @click.stop="onClickDeleteMark(item)"
                          title="Xóa điểm"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </template></v-data-table
                  >
                </template>
              </div>
              <p v-else class="px-4 py-2 pt-4 mb-0">Bạn không có quyền xem phiếu điểm</p>
            </div>
          </div>
        </v-flex></v-layout
      >
    </v-card>
    <BaseDialog
      v-if="editMarkNoteDialog.isOpen"
      :isOpen="editMarkNoteDialog.isOpen"
      :title="editMarkNoteDialog.title"
      @close="editMarkNoteDialog.isOpen = false"
      @cancel="editMarkNoteDialog.onCancel"
      @confirm="editMarkNoteDialog.callback"
      :isSubmitting="editMarkNoteDialog.isSubmitting"
    >
      <v-form lazy-validation ref="editMarkNoteDialog" @submit="onSubmitEditMarkNote">
        <v-card-text>
          <v-textarea label="Mô tả" v-model="editMarkNoteDialog.currentItem.note"> </v-textarea>
        </v-card-text>
      </v-form>
    </BaseDialog>
    <BaseDialog
      v-if="editMarkSheetDialog.isOpen"
      :isOpen="editMarkSheetDialog.isOpen"
      :title="editMarkSheetDialog.title"
      @close="editMarkSheetDialog.isOpen = false"
      @cancel="editMarkSheetDialog.onCancel"
      @confirm="editMarkSheetDialog.callback"
      :isSubmitting="editMarkSheetDialog.isSubmitting"
    >
      <v-form lazy-validation ref="editMarkSheetDialog" @submit="onSubmitEditMarkSheet">
        <v-card-text>
          <v-text-field
            :rules="[$rules.required]"
            required
            label="Tiêu đề"
            v-model="editMarkSheetDialog.currentItem.title"
          ></v-text-field>
          <autocomplete-teacher
            :rules="[$rules.required]"
            v-model="editMarkSheetDialog.currentItem.assigned_teacher"
            item-text="name"
            item-value="id"
            label="Giáo viên chấm"
          ></autocomplete-teacher>
          <v-textarea label="Mô tả" v-model="editMarkSheetDialog.currentItem.note"> </v-textarea>
        </v-card-text>
      </v-form>
    </BaseDialog>
    <BaseDialog
      v-if="editMarkDialog.isOpen"
      :isOpen="editMarkDialog.isOpen"
      :title="editMarkDialog.title"
      @close="editMarkDialog.isOpen = false"
      @cancel="editMarkDialog.onCancel"
      @confirm="editMarkDialog.callback"
      :isSubmitting="editMarkDialog.isSubmitting"
    >
      <v-form
        :valid="editMarkDialog.valid"
        lazy-validation
        ref="editMarkDialog"
        @submit="onSubmitEditMark"
      >
        <v-card-text>
          <!-- <v-text-field
            :rules="[$rules.required]"
            required
            label="Điểm"
            v-model="editMarkDialog.currentItem.value"
            type="number"
            min="0"
            max="10"
            step="0.5"
          ></v-text-field>
          <v-text-field
            v-model="editMarkDialog.currentItem.drive_link"
            label="Link bài tập"
            :rules="[$rules.url]"
          ></v-text-field>
          <v-textarea label="Ghi chú" v-model="editMarkDialog.currentItem.note"> </v-textarea> -->
          <div class="d-flex flex-column flex-fill overflow-auto pr-1 item-list">
            <div
              v-for="st in editMarkDialog.data"
              :key="st._id"
              class="d-flex flex-row align-center mt-2"
            >
              <span class="flex-fill">
                {{ st.name }}
                <!-- <v-tooltip v-if="!studentQualificationStatus[st._id]" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" slot="activator">mdi-information</v-icon>
                    </template>
                    Sinh viên không đủ điều kiện tham gia lớp học
                  </v-tooltip> -->
              </span>
              <v-text-field
                v-if="editMarkDialog.attribute === 'value'"
                min="0"
                max="10"
                step="0.5"
                type="number"
                hide-details="auto"
                style="min-width: 150px; width: 150px; flex: 0 0 100px"
                v-model="(st.mark || {})[editMarkDialog.attribute]"
                filled
                dense
                :rules="[$rules.max(10), $rules.min(0)]"
                :disabled="!(st.learningResult || {}).qualifyForFinalExam"
              ></v-text-field>
              <v-text-field
                v-else
                type="url"
                placeholder="http://"
                hide-details="auto"
                style="min-width: 150px; width: 250px; flex: 0 0 250px"
                v-model="(st.mark || {})[editMarkDialog.attribute]"
                filled
                dense
                :rules="[$rules.url]"
              ></v-text-field>
            </div>
          </div>
        </v-card-text>
        <input type="submit" value="" style="display: none" />
      </v-form>
    </BaseDialog>
  </div>
</template>
<script>
import { round } from 'number-precision'

import { saveAs } from 'file-saver'
import XLSX from 'xlsx'
import BaseDialog from '@/components/base/BaseDialog'
import { groupBy } from 'rxjs/internal/operators/groupBy.js'
import { mapState, mapActions, mapGetters } from 'vuex'
import BaseTableSkeletonLoader from '@/components/base/BaseTableSkeletonLoader'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import moment from 'moment'
import _ from 'lodash'
import AutocompleteTeacher from '@/components/basic/input/AutocompleteTeacher'
import MarkBreadcrumb from '@/modules/class/marks/MarkBreadcrumb'
import { RetestMarkSheet } from '../../../plugins/api'

export default {
  components: {
    MarkBreadcrumb,
    AutocompleteTeacher,
    BaseDialog,
    Breadcrumbs,
    BaseTableSkeletonLoader
  },
  data() {
    return {
      isLoading: false,
      headers: [
        { text: 'STT', value: 'index' },
        { text: 'Họ và tên', value: 'name' },
        { text: 'Điểm', value: 'mark.value' },
        { text: 'Link bài tập', value: 'mark.drive_link' },
        { text: 'Ghi chú', value: 'mark.note' },
        { text: 'Hành động', value: 'actions' }
      ],
      editMarkSheetDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        callback: () => {},
        onCancel: () => {
          this.editMarkSheetDialog.isOpen = false
        }
      },
      editMarkDialog: {
        data: [],
        isOpen: false,
        title: '',
        valid: true,
        attribute: null,
        callback: () => {},
        onCancel: () => {
          this.editMarkDialog.isOpen = false
        }
      },
      editMarkNoteDialog: {
        data: [],
        isOpen: false,
        title: '',
        valid: true,
        callback: () => {},
        onCancel: () => {
          this.editMarkNoteDialog.isOpen = false
        }
      }
    }
  },
  computed: {
    ...mapGetters('classDetail', ['classData', 'finalCourseMark']),
    ...mapState('classDetail', [
      'retestMarkSheets',
      'retestMarks',
      'students',
      'marks',
      'learningResults',
      'isLoadingRetestMarks',
      'isLoadingRetestMarkSheets',
      'isInitData'
    ]),
    ...mapState('auth', ['user']),
    isLocked() {
      if (!this.classData) {
        return false
      }
      return this.classData.markTableLocked
    },

    canEditMark() {
      if (!this.user) {
        return false
      }
      return (
        ['education_manager', 'super_admin'].includes(this.user.role.type) ||
        this.user.role.type === 'teacher'
      )
    },
    canEditMarkSheet() {
      if (!this.user) {
        return false
      }
      return ['education_manager', 'super_admin'].includes(this.user.role.type)
    },
    isSuperUser() {
      if (!this.user) {
        return false
      }
      return ['super_admin'].includes(this.user.role.type)
    },
    isClassDataEmpty() {
      return _.isEmpty(this.classData)
    },
    markSheetData() {
      if (!this.retestMarkSheets || !this.retestMarkSheets.length) {
        return null
      }
      return this.retestMarkSheets[0]
    },
    canSeeMarkSheets() {
      if (!this.user || !this.user.role) {
        return false
      }
      if (
        ['manager', 'accountant', 'super_admin', 'education_manager'].includes(this.user.role.type)
      ) {
        return true
      }
      if (!this.markSheetData) {
        return false
      }
      if (this.markSheetData.assigned_teacher.code === this.user.username) {
        return true
      }
      return false
    },
    tableData() {
      if (!this.markSheetData) {
        return []
      }
      if (_.isEmpty(this.students)) {
        return []
      }
      if (!this.marks || !this.marks.length) {
        return []
      }
      const raw = Object.values(this.students)
        .map(({ id, ...s }) => {
          const mark = this.retestMarks.find(m => m.student.id === id)
          const finalMark = this.marks.find(
            l => l.courseMark.type === 'final' && l.student.id === id
          )
          const learningResult = this.learningResults.find(l => l.student.id === id) || {}
          const output = { ...s, id, mark: mark || {}, finalMark, learningResult }

          if (mark) {
            return output
          }

          if (!learningResult || !learningResult.qualifyForFinalExam) {
            return null
          }

          // if (!finalMark || !learningResult) {
          //   return null
          // }

          if (finalMark && finalMark.value < 5) {
            return output
          }

          // if (
          //   learningResult.qualifyForFinalExam &&
          //   finalMark.valueFromMarkElements !== null &&
          //   finalMark.valueFromMarkElements !== undefined &&
          //   finalMark.valueFromMarkElements < 5
          // ) {
          //   return output
          // }
          return null
        })
        .filter(Boolean)
        .map((i, index) => ({
          ...i,
          'row-class': [
            'row-class',
            ...((i.learningResult || {}).qualifyForFinalExam === true
              ? []
              : ['unqualify-final-exam'])
          ]
        }))

      const twoGroup = _.partition(raw, i => {
        const qualified = (i.learningResult || {}).qualifyForFinalExam === true
        // &&          (!this.shouldCheckQualification || this.studentQualificationStatus[i.id])

        return qualified
      })

      return twoGroup.flat().map((i, index) => ({ ...i, index }))
    }
  },
  methods: {
    ...mapActions('classDetail', [
      'initClass',
      'fetchRetestMarkSheets',
      'fetchRetestMarks',
      'updateRetestMarkSheet',
      'updateRetestMark',
      'createRetestMarkSheet',
      'createRetestMark',
      'deleteRetestMarkSheet',
      'deleteRetestMark',
      'updateManyRetestMarks',
      'fetchLearningResults',
      'fetchMarks'
    ]),
    onRowClick(item) {
      if (!this.canEditMark) {
        return
      }
      this.onClickEditMark(item)
    },

    async onClickSyncCourseMapConfig() {
      const sheetId = this.markSheetData.id
      if (!sheetId) {
        return
      }
      await RetestMarkSheet.mapCourseMarkConfig(sheetId)
      this.$alert.success('Đồng bộ thành công')
    },
    onClickDeleteSheet() {
      if (!this.markSheetData) {
        return
      }
      const sheetId = this.markSheetData.id
      this.$dialog.confirm({
        title: 'Xóa phiếu điểm',
        text: 'Xóa phiếu điểm, và các liên kết sử dụng phiếu điểm này',
        okText: 'Yes',
        cancelText: 'No',
        done: (async () => {
          try {
            await this.deleteRetestMarkSheet(sheetId)
            this.$alert.success('Xóa thành công')
          } catch (error) {
            this.$alert.error('Có lỗi xảy ra')
          } finally {
            // Promise.all(
            //   this.fetchMarks({ id: this.$route.params.id }),
            //   this.fetchLearningResults({ id: this.$route.params.id })
            // )
          }
        }).bind(this)
      })
    },
    onClickDeleteMark(item) {
      if (!(item || {}).mark) {
        return
      }
      const markId = item.mark.id
      this.$dialog.confirm({
        title: 'Xóa điểm',
        text: 'Dữ liệu sẽ không thể khôi phục, bạn có chắc chắn muốn tiếp tục',
        okText: 'Yes',
        cancelText: 'No',
        done: (async () => {
          try {
            await this.deleteRetestMark(markId)
            this.$alert.success('Xóa thành công')
          } catch (error) {
            this.$alert.error('Có lỗi xảy ra')
          }
        }).bind(this)
      })
    },

    onClickEditMark(attribute = 'value') {
      if (!this.markSheetData) {
        return
      }
      this.editMarkDialog.isOpen = true
      this.editMarkDialog.title = attribute === 'value' ? 'Sửa điểm' : 'Sửa link drive'
      this.editMarkDialog.data = _.cloneDeep(this.tableData)
      this.editMarkDialog.attribute = attribute
      this.editMarkDialog.callback = (async () => {
        this.editMarkDialog.valid = this.$refs.editMarkDialog.validate()
        if (!this.editMarkDialog.valid) {
          this.$alert.error('Lỗi form! Vui lòng kiểm tra lại')
          return
        }
        try {
          const payload = this.editMarkDialog.data
            .map(st => {
              const match = this.tableData.find(student => student.id === st.id)
              const previousValue = (match.mark || {})[attribute]
              let currentValue = (st.mark || {})[attribute]
              if (attribute === 'value') {
                if (typeof currentValue === 'string') {
                  currentValue = parseFloat(currentValue)
                  if (isNaN(currentValue)) {
                    currentValue = undefined
                  }
                  if (typeof currentValue === 'number') {
                    currentValue = round(currentValue, 2)
                  }
                }
              } else if (attribute === 'drive-link') {
                if (!currentValue) {
                  currentValue = undefined
                }
              }
              if (currentValue !== previousValue) {
                const { value, drive_link, note, id } = match.mark || {}

                return {
                  ...{
                    id,
                    value: value || null,
                    drive_link: drive_link || null,
                    note: note || null
                  },
                  [attribute]: currentValue === undefined ? null : currentValue,
                  student: st.id,
                  class: this.classData.id,
                  courseMark: this.finalCourseMark.id,
                  course: this.classData.course.id,
                  retest_mark_sheet: this.markSheetData.id
                }
              }
            })
            .filter(Boolean)

          await this.updateManyRetestMarks({ data: payload })
          this.$alert.success('Cập nhật thành công')
        } catch (error) {
          this.$alert.error('Có lỗi xảy ra')
          this.fetchRetestMarks(this.$route.params.id)
        } finally {
          this.editMarkDialog.onCancel()
          // Promise.all(
          //   this.fetchMarks({ id: this.$route.params.id }),
          //   this.fetchLearningResults({ id: this.$route.params.id })
          // )
        }
      }).bind(this)
    },
    onSubmitEditMark(e) {
      e.preventDefault()
      this.editMarkDialog.callback()
    },
    onSubmitEditMarkSheet(e) {
      e.preventDefault()
      this.editMarkSheetDialog.callback()
    },
    onSubmitEditMarkNote(e) {
      e.preventDefault()
      this.editMarkNoteDialog.callback()
    },
    async init() {
      this.isLoading = true
      await Promise.allSettled([
        this.initClass({ id: this.$route.params.id }),
        this.fetchRetestMarkSheets(this.$route.params.id),
        this.fetchRetestMarks(this.$route.params.id)
      ])
      this.isLoading = false
    },
    onClickEditMarkSheet() {
      this.editMarkSheetDialog.isOpen = true
      this.editMarkSheetDialog.title = 'Sửa phiếu điểm'
      this.editMarkSheetDialog.currentItem = this.markSheetData
        ? _.cloneDeep(this.markSheetData)
        : {
            title: `Phiếu điểm thi lại (${moment().format('DD/MM/YYYY')})`,
            note: '',
            assigned_teacher: undefined,
            class: this.classData.id,
            course_mark_config: this.classData.course_mark_config.id,
            course: this.classData.course.id
          }
      this.editMarkSheetDialog.callback = (async () => {
        this.editMarkSheetDialog.valid = this.$refs.editMarkSheetDialog.validate()
        if (!this.editMarkSheetDialog.valid) {
          this.$alert.error('Lỗi form! Vui lòng kiểm tra lại')
          return
        }

        try {
          if (!this.markSheetData) {
            await this.createRetestMarkSheet({ data: this.editMarkSheetDialog.currentItem })
            this.$alert.success('Tạo thành công')
            return
          }
          if (!this.editMarkSheetDialog.currentItem) {
            return
          }
          const { _id, id, ...o } = this.editMarkSheetDialog.currentItem

          await this.updateRetestMarkSheet({ id, ...o })
          this.$alert.success('Cập nhật thành công')
        } catch (error) {
          this.$alert.error('Có lỗi xảy ra')
          this.fetchRetestMarkSheets(this.$route.params.id)
        } finally {
          this.editMarkSheetDialog.onCancel()
        }
      }).bind(this)
    },
    onClickEditMarkNote(item) {
      this.editMarkNoteDialog.isOpen = true
      this.editMarkNoteDialog.title = 'Sửa ghi chú'
      this.editMarkNoteDialog.currentItem = _.cloneDeep(item.mark)
      this.editMarkNoteDialog.callback = (async () => {
        this.editMarkNoteDialog.valid = this.$refs.editMarkNoteDialog.validate()
        if (!this.editMarkNoteDialog.valid) {
          this.$alert.error('Lỗi form! Vui lòng kiểm tra lại')
          return
        }

        const { note, id } = this.editMarkNoteDialog.currentItem

        try {
          await this.updateRetestMark({ note: note || null, id })
          this.$alert.success('Cập nhật thành công')
        } catch (error) {
          this.$alert.error('Có lỗi xảy ra')
          this.fetchRetestMarks(this.$route.params.id)
        } finally {
          this.editMarkNoteDialog.onCancel()
        }
      }).bind(this)
    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

::v-deep {
  th,
  td {
    background-color: #fff;
  }
  th {
    z-index: 1;
  }
  th:first-child {
    z-index: 2;
  }
  thead {
    tr:first-child th {
      position: sticky;
      top: -1px;
    }
    tr:nth-child(2) th {
      position: sticky;
      top: 64px;
    }
    th {
      z-index: 1;
    }
  }

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
  }

  .v-data-table__wrapper {
    height: calc(100vh - 312px);
    overflow-x: auto;
    overflow-y: auto;
  }

  .mark-note,
  .drive-link {
    text-transform: unset;
    font-weight: normal;
    max-width: 80px;
  }
  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    .mark-note,
    .drive-link {
      max-width: 200px;
    }
    .v-data-table__wrapper {
      height: calc(100vh - 313px);
    }
  }
  .row-class {
    // cursor: pointer;
  }
  .row-class.unqualified-student,
  .row-class.unqualify-final-exam {
    cursor: default;
  }
  --disabled-color: rgb(218, 218, 218);

  .unqualified-student td {
    background-color: var(--disabled-color);
    .v-data-table__checkbox {
      display: none;
    }
  }
  .unqualify-final-exam td {
    background-color: var(--disabled-color);
  }
}

.show-mark-sheet-item {
  display: block;
}
.show-mark-sheet-label {
  width: 200px;
  display: inline-block;
}
.show-mark-sheet-value {
  display: inline;
}
</style>
